import { RefObject, useState, useEffect } from 'react';

import { isDefined } from '@utils/filterPredicates';

/**
 * @description Determines if the ref passed to the hook is currently visible on the screen.
 * Returns true if it is currently visible on the screen, false if it isn't
 *
 * @param ref
 * @param isEnabled
 * @param options
 * @returns
 */

export function useIsElementVisible(
  ref: RefObject<HTMLElement>,
  isEnabled: boolean = true,
  options?: IntersectionObserverInit,
) {
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    const observer = isEnabled
      ? new IntersectionObserver(
          ([entry]) => setIsIntersecting(entry?.isIntersecting ?? false),
          options,
        )
      : undefined;

    if (isDefined(observer) && ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer?.disconnect();
    };
  }, [isEnabled, ref, options]);

  return isIntersecting;
}
